import {SESSION_STORAGE_ATTEMPT_TO_BUY_TICKET_INFO} from '../constant';
import {AttemptToBuyTicketInfo} from '../type';

export function storeAttemptToBuyTicketInfoToSessionStorage({
  attemptToBuyTicketInfo,
}: {
  attemptToBuyTicketInfo: AttemptToBuyTicketInfo | null;
}) {
  if (!attemptToBuyTicketInfo) {
    return;
  }

  window.sessionStorage.setItem(
    SESSION_STORAGE_ATTEMPT_TO_BUY_TICKET_INFO,
    JSON.stringify(attemptToBuyTicketInfo)
  );
}
